// Shared demand-level styling for the forecast + calendar views.
export const LEVEL = {
  critical: { bar: "bg-rose-500", chip: "bg-rose-50 text-rose-700 border-rose-200", track: "bg-rose-100", dot: "bg-rose-500" },
  busy: { bar: "bg-amber-500", chip: "bg-amber-50 text-amber-700 border-amber-200", track: "bg-amber-100", dot: "bg-amber-500" },
  moderate: { bar: "bg-sky-500", chip: "bg-sky-50 text-sky-700 border-sky-200", track: "bg-sky-100", dot: "bg-sky-500" },
  quiet: { bar: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", track: "bg-emerald-100", dot: "bg-emerald-500" },
};

export const lvl = (level) => LEVEL[level] || LEVEL.quiet;
